import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
  { name: 'Início', path: '/' },
  { name: 'Sugestões de Músicas', path: '/musicas' },
  { name: 'Portfólio', path: '/portfolio' },
  { name: 'Contato', path: '/contato' }];


  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/images/logo.png"
              alt="Harmonia Nupcial"
              className="h-14 md:h-16 w-auto" />

          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-[#B30310] ${
              isActive(link.path) ?
              'text-[#B30310] border-b-2 border-[#CDAD1E]' :
              'text-[#920216]'}`
              }>

                {link.name}
              </Link>
            )}
          </nav>

          {/* CTA Button Desktop */}
          <div className="hidden md:block">
            <Button
              asChild
              className="bg-[#B30310] hover:bg-[#920216] text-white transition-all duration-300">

              <Link to="/contato">Fale Conosco</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#920216] hover:text-[#B30310] transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu">

            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen &&
        <nav className="md:hidden pb-6 animate-in slide-in-from-top-5 duration-300">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMenuOpen(false)}
              className={`text-sm font-medium tracking-wide py-2 transition-colors ${
              isActive(link.path) ?
              'text-[#B30310]' :
              'text-[#920216] hover:text-[#B30310]'}`
              }>

                  {link.name}
                </Link>
            )}
              <Button
              asChild
              className="bg-[#B30310] hover:bg-[#920216] text-white w-full mt-2"
              onClick={() => setIsMenuOpen(false)}>

                <Link to="/contato">Fale Conosco</Link>
              </Button>
            </div>
          </nav>
        }
      </div>
    </header>);

};

export default Header;